import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1676428133334'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='4740'
    >
        <path
            d='M1022.583467 127.803733 894.779733 0 511.291733 383.4624 127.8464 0 0 127.803733 383.496533 511.274667 0 894.737067 127.8464 1022.5408 511.291733 639.0784 894.779733 1022.5408 1022.583467 894.737067 639.138133 511.274667Z'
            fill='currentColor'
            p-id='4741'
        ></path>
    </svg>
)

export const DeleteIcon = props => <Icon component={SVG} {...props} />
